import type { PatientFindingView } from '@app/icare/entities/patientFinding/schema/PatientFinding'
import { entityRegistry } from '@app/icare/entities/registry'
import { Badge, Flex, Space, Tooltip } from 'antd'
import { FindingsBadge } from './FindingsBadge'
import { FindingsMessages } from './FindingsMessages'
import { FindingsSelector } from './FindingsSelector'

export type FindingsLabelProps = (
  | {
      label: React.ReactNode
      entity?: undefined
    }
  | { entity: keyof typeof entityRegistry; label?: undefined }
) &
  (
    | {
        selector: (findings: PatientFindingView[]) => PatientFindingView[]
        findings?: undefined
      }
    | {
        selector?: undefined
        findings: PatientFindingView[]
      }
  )

const minimalistic = true

export function FindingsLabel({ label, entity, selector, findings }: FindingsLabelProps) {
  if (entity) {
    const config = entityRegistry[entity]
    label = config.labelPlural
  }

  if (!selector && findings) {
    return <Label minimalistic={minimalistic} findings={findings} label={label} />
  }

  return (
    <FindingsSelector
      selector={selector}
      children={findings => <Label minimalistic={minimalistic} findings={findings} label={label} />}
    />
  )
}

const Label = ({
  minimalistic,
  findings,
  label,
}: {
  minimalistic: boolean
  findings: PatientFindingView[]
  label: React.ReactNode
}) => {
  if (findings.length === 0) {
    return <span>{label}</span>
  }

  return minimalistic ? (
    <Tooltip placement={'bottom'} color="white" title={<FindingsMessages findings={findings} />}>
      <Flex gap="small" style={{ display: 'inline-flex' }}>
        <Badge status="error" />
        {label}
      </Flex>
    </Tooltip>
  ) : (
    <Space>
      {label}
      <FindingsBadge findings={findings} />
    </Space>
  )
}
